<template>
    <div>

        <b-modal
        class="main-modal"
        ref="showRulesModal"
        size="lg"
        ok-only
        ok-title="Done"
        >
            <div class="d-block">

                <rules-text></rules-text>

            </div>
        </b-modal>

    </div>
</template>

<script>
export default {
    name: 'rules-modal',
    data () {
        return {
        }
    },
    methods: {
        //
        // Modals
        //
        showRulesModal () {
            this.$refs.showRulesModal.show()
        }
    },
    mounted () {
        // Register Modals
        this.$root.$on('showRulesModal', () => { this.showRulesModal() })
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';
</style>
